import { render, staticRenderFns } from "./GlobalSideMenu.vue?vue&type=template&id=a62167e0&scoped=true&"
import script from "./GlobalSideMenu.vue?vue&type=script&lang=js&"
export * from "./GlobalSideMenu.vue?vue&type=script&lang=js&"
import style0 from "./GlobalSideMenu.vue?vue&type=style&index=0&id=a62167e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a62167e0",
  null
  
)

export default component.exports